// extracted by mini-css-extract-plugin
export default {"wrapper":"Toggle_wrapper__jsx9P","active":"Toggle_active__+r5YS"};